var map = {
	"./DSC_4272.jpg": "6d98",
	"./Sisustuslauantai etusivu.jpg": "896b",
	"./Slide001.jpg": "03eb",
	"./Slide002.jpg": "ce66",
	"./Slide003.jpg": "71b7",
	"./Slide004.jpg": "c03c",
	"./Slide005.jpg": "95b6",
	"./Slide006.jpg": "9f11",
	"./Slide007.jpg": "7347",
	"./etusivu1.jpg": "26f2",
	"./etusivu2.jpg": "2d31",
	"./etusivu3.jpg": "9826",
	"./slide-1.jpg": "22aa",
	"./slide-2.jpg": "26f8",
	"./slide-3.jpg": "258e",
	"./slide-4.jpg": "9887"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "134d";